import { Subscription } from 'rxjs';
import { PopupCategories } from 'shared-library';
import { Component, OnInit } from '@angular/core';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { QrGeneratorNavigatorSteps } from '@app/store/enums/qr-generator-navigator-steps.enum';
import { PopupGeneratorNavigator } from '@app/store/models/popup-generator-navigator.interface';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';

@Component({
  selector: 'app-shared-popup-preview-slidein',
  templateUrl: './shared-popup-preview-slidein.component.html',
  styleUrls: ['./shared-popup-preview-slidein.component.scss']
})
export class SharedPopupPreviewSlideinComponent implements OnInit {


  create_mode = !window.location.href.includes("edit")

  session_info: SessionInfo
  data: PopupGeneratorNavigator
  private subscriptions: Subscription[] = []

  constructor(
    private coreService: CoreService,
    public functions: FunctionsService,
    private qrGeneratorService: UserQrGeneratorService
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => {
      this.session_info = si
      if (this.session_info) {
        if (this.create_mode) {
          this.data = this.session_info.popup_generating.drafts.find(d => d.selected_category === PopupCategories.SLIDE_IN)
        } else {
          this.data = this.session_info.popup_generating.updating
        }

        if (this.data?.active_step === QrGeneratorNavigatorSteps.START) {
          // show demo data instead
          this.data.slidein_data = JSON.parse(JSON.stringify(this.qrGeneratorService.initSlideInCategoryData()))
          this.data.slidein_data.headings.main = "Flash sale!"
          this.data.slidein_data.headings.meta = "Shop now to get 20% off!"
          this.data.slidein_data.banner.show = false
          this.data.slidein_data.right_to_view = false
          this.data.slidein_data.cta.title = "Buy now"
          this.data.slidein_data.colors.text_color = "#ffffff"
          this.data.slidein_data.colors.primary_color = "#252525"
          this.data.slidein_data.colors.secondary_color = "#d92027"
        }
      }
    }))
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe())
  }


}
